import { render, staticRenderFns } from "./copyModuleField.vue?vue&type=template&id=a438336c&scoped=true&lang=pug"
import script from "./copyModuleField.vue?vue&type=script&lang=js"
export * from "./copyModuleField.vue?vue&type=script&lang=js"
import style0 from "./copyModuleField.vue?vue&type=style&index=0&id=a438336c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a438336c",
  null
  
)

export default component.exports